import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import { Button } from '@material-ui/core'
import { ReactComponent as ViberSvgIcon } from '../../assets/img/viber.svg'

const useStyles = makeStyles((theme) => ({
  viberButton: {
    backgroundColor: '#665CAC', // Viber purple
    color: '#fff',
    textTransform: 'none',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#574f9c',
    },
    borderRadius: '6px',
    padding: '6px',
  },

  viberIcon: {
    width: '24px',
    height: '24px',
  },
}))

const ViberButton = ({ children }) => {
  const classes = useStyles()

  const handleClick = () => {
    window.open('https://appurl.io/hnAPtAO1Yv', '_blank')
  }

  return (
    <Button
      onClick={handleClick}
      startIcon={<ViberSvgIcon className={classes.viberIcon} />}
      className={classes.viberButton}
    >
      {children}
    </Button>
  )
}

ViberButton.displayName = 'ViberButton'
export { ViberButton }
export default ViberButton
